export default function usePayment() {
  const payDeposit = (applicationId) => {
    window.location.href = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/payment/${applicationId}`;
  };

  return {
    payDeposit,
  };
}
